import classNames from "classnames";
import { generateRandomID } from "../../../helpers/utilities";
import "./checkbox.style.scss";

export interface CheckBoxProps {
  value?: string | number | boolean;
  label: string;
  onChange?: (e?: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  testId?: string;
  disabled?: boolean;
  name: string;
  hook?: any;
  checked?: boolean;
  defaultValue?: boolean;
  hasError?: boolean;
}

export const CheckBox = (props: CheckBoxProps) => {
  const id = generateRandomID();

  return (
    <div className={"checkbox-wrapper"}>
      <input
        {...props?.hook}
        onChange={props.onChange}
        defaultChecked={props?.defaultValue}
        type={"checkbox"}
        className={classNames("checkbox", props?.className)}
        data-testid={props?.testId ?? "checkbox-test"}
        disabled={props?.disabled}
        name={props.name}
        id={id}
      />
      <label
        className={classNames("checkbox-tick", props?.className, {"hasError": props.hasError})}
        htmlFor={id}
      />
      <p className="checkbox-txt">{props.label}</p>
    </div>
  )
}
